/* eslint-disable camelcase */
import React, { Component } from 'react'
import styled from 'styled-components'
import Tabs from 'components/Tabs'
import TariffSubscribeForm from 'components/TariffSubscribeForm'
import Modal from 'components/Modal'
import Logic from './logic'
import Smiley from './assets/ic-aceitar.svg'
import InfoIcon from './assets/ic-informacao.svg'
import Loading from 'components/Loading'
import {
  isPhone,
  isEmail,
  isContactPhone,
  hasBillingAddress,
  required,
  cepCui,
  hasPaidServices,
  isChecked,
  isNIF,
  notEmptyEmail,
  notEmptyPhone,
} from './validations'

import mapValues from 'lodash/mapValues'

import { isArray, omit } from 'lodash'
import { isEnterprise, isSimple, isAdvanced } from 'config'
import { unitCurrency } from 'utils'

const translateErrors = {
  first_name: 'Primeiro Nome',
  last_name: 'Último Nome',
  tax_id: 'NIF',
  email: 'Email',
  phone_number: 'Telefone / Telemóvel',
  company_phone_number: 'Telefone / Telemóvel Contacto',
  company_name: 'Nome da empresa',
  company_cae: 'CAE da empresa',
  company_email: 'Email empresa',
  legal_bi: 'BI/CC do Representante legal',
  street: 'Rua',
  door: 'Nº da porta',
  floor: 'Andar',
  postal_code: 'Código postal',
  billing_address: 'Morada de faturação',
  billing_street: 'Rua de faturação',
  billing_door: 'Nº da porta de faturação',
  billing_floor: 'Andar de faturação',
  billing_postal_code: 'Código postal de faturação',
  cpe: 'CPE',
  cui: 'CUI',
  cuicpe: ['CUI', 'CPE'],
}

@Logic
class TariffSubscribeModal extends Component {
  constructor() {
    super()
    this.state = {
      index: 0,
      currentTariff: null,
      open: false,
      errorOpened: true,
      showedDisclaimer: true,
      canSub: true,
    }

    this.adhereButtons = [
      {
        label: 'cancelar',
        primary: false,
        click: () => this.toggleModal(),
        color: '#006736',
      },
      {
        label: 'seguinte',
        primary: true,
        click: this.adhereActions,
      },
    ]
  }

  isFormValid = (validations) => {
    const key = Object.keys(validations)[0]
    const list = validations[key]
    const formBase = this.props.formData[key]

    let invalid = { [key]: {} }
    mapValues(list, (funcs, valueKey) => {
      for (var index = 0; index < funcs.length; index++) {
        let func = funcs[index]
        let doFirst = true
        if (isArray(func)) {
          func = func[0]
          doFirst = false

          if (!func(formBase[valueKey].value, formBase)) {
            break
          }
        }
        if (doFirst) {
          if (formBase[valueKey]) {
            const { result, message } = func(formBase[valueKey].value, formBase)
            if (!result) {
              invalid[key][valueKey] = message
              break
            }
          }
        }
      }
    })

    if (this.props.tariffInfo && key === 'personal') {
      const {
        subscription_requires_email,
        subscription_requires_phone,
      } = this.props.tariffInfo.entity
      let emailKey = 'email'
      let phoneKey = 'phone'
      if (isEnterprise) {
        emailKey = 'companyEmail'
        phoneKey = 'companyPhoneNumber'
      }
      if (!subscription_requires_email && !subscription_requires_phone) {
        const phone = this.props.formData.personal[phoneKey]
        const email = this.props.formData.personal[emailKey]

        const emailVal = notEmptyEmail(email.value, phone.value)
        const phoneVal = notEmptyPhone(phone.value, email.value)

        if (!invalid.personal[phoneKey] && !emailVal.result) {
          invalid.personal[emailKey] = emailVal.message
        }
        if (!invalid.personal[emailKey] && !phoneVal.result) {
          invalid.personal[phoneKey] = phoneVal.message
        }
      }
    }
    return { valid: !Object.keys(invalid[key]).length, invalid }
  }

  transformForm = (form) => {
    if (!form) {
      return false
    }

    // mess
    const { personal, billing, electric, gas } = form
    const {
      name: first_name,
      surname: last_name,
      nif: tax_id,
      email,
      phone: phone_number,
      contact,
      companyName,
      companyCae,
      companyPhoneNumber,
      companyEmail,
      legalBi,
    } = personal

    const {
      street,
      door,
      floor,
      district,
      municipality,
      billingDoor,
      billingFloor,
      billingDistrict,
      billingMunicipality,
      billingStreet,
      directDebit,
      electronicBilling,
      billingAddress,
    } = billing
    const {
      cpe,
      potency: hired_power,
      tariff: time_cycle,
      cycle: price_list_cycle,
    } = electric
    const { cui, tier: price_step } = gas
    const { id: price_list } = this.props.tariffInfo

    let gasFields = {
      current_gas_entity: this.props.tariffInfo.entity.id,
      cui: cui.value,
      price_step: price_step.value,
    }

    let eletricityFields = {
      current_electricity_entity: this.props.tariffInfo.entity.id,
      hired_power: hired_power.value,
      cpe: cpe.value,
      time_cycle: time_cycle.value,
      price_list_cycle: price_list_cycle.value,
    }

    // Subscription source
    let subscription_source
    if (isSimple) {
      subscription_source = 'simple_simulator'
    }

    if (this.props.isHome) {
      subscription_source = 'simple_simulator'
    }

    if (isAdvanced) {
      subscription_source = 'advanced_simulator'
    }

    if (isEnterprise) {
      subscription_source = 'enterprise_simulator'
    }

    const priceListId = this.props.tariffInfo.priceListObject.priceListId

    // Set the personal object to the correct one based on simulator
    let personalObj = {}
    const isEleContract = !!(
      this.props.tariffInfo &&
      this.props.tariffInfo.pricelistadditionalinfo.electronic_contract
    )

    if (isEnterprise) {
      personalObj = {
        first_name: first_name.value,
        last_name: last_name.value,
        tax_id: tax_id.value,
        company_name: companyName.value,
        company_cae: companyCae.value,
        company_phone_number: companyPhoneNumber.value,
        company_email: companyEmail.value,
        legal_bi: legalBi.value,
        contact: contact.value,
        email: email.value,
        phone_number: phone_number.value,
      }
    } else {
      personalObj = {
        first_name: first_name.value,
        last_name: last_name.value,
        tax_id: tax_id.value,
        email: email.value,
        phone_number: phone_number.value,
        contact: contact.value,
      }

      if (isEleContract) {
        personalObj = omit(personalObj, ['tax_id', 'contact'])
      }
    }

    let obj = {
      ...personalObj,
      street: street.value,
      door: door.value,
      floor: floor.value,
      billing_street: billingStreet.value,
      billing_door: billingDoor.value,
      billing_floor: billingFloor.value,
      billing_detail: `${
        electronicBilling.value === 'false' ? '' : electronicBilling.value
      }${directDebit.value === 'false' ? '' : directDebit.value}`,
      billing_address: billingAddress.value,
      billing_district: billingDistrict.value,
      billing_municipality: billingMunicipality.value,
      contract_summary: {},
      price_list: price_list,
      user: '',
      district: district.value,
      municipality: municipality.value,
      subscription_source,
      simulation_price_list: priceListId,
    }

    if (this.state.currentTariff.electricityPriceList) {
      obj = { ...obj, ...eletricityFields }
    }

    if (this.state.currentTariff.gasPriceList) {
      obj = { ...obj, ...gasFields }
    }

    return obj
  }

  adhereActions = () => {
    let maxTabs = this.state.tabs.length - 1
    let valid = true
    let invalid
    // if (this.state.currentTariff.electricityPriceList && this.state.currentTariff.gasPriceList) {
    //   maxTabs = 4
    // }

    // if (isSimple) {
    //   maxTabs = 2
    // }

    if (this.state.index <= maxTabs) {
      const validation = this.isFormValid(this.validations[this.state.index])
      valid = validation.valid
      invalid = validation.invalid
    }

    if (valid) {
      this.actions.recheckValids()
      if (this.state.index < maxTabs) {
        this.tabChange(this.state.index + 1)
      } else {
        this.actions.submitForm(this.transformForm(this.props.formData))
      }
    } else {
      this.actions.setInvalid(invalid)
    }
  }

  tabChange = (index) => {
    let valid = true
    let invalid
    if (index > this.state.index) {
      const validation = this.isFormValid(this.validations[this.state.index])
      valid = validation.valid
      invalid = validation.invalid
    }

    if (valid) {
      if (index === this.state.tabs.length - 1) {
        this.adhereButtons = [
          {
            label: 'anterior',
            primary: false,
            click: () =>
              this.state.index > 0 && this.tabChange(this.state.index - 1),
            color: '#006736',
          },
          {
            label: 'Aderir',
            primary: true,
            click: this.adhereActions,
          },
        ]
      } else if (index === 0) {
        this.adhereButtons = [
          {
            label: 'seguinte',
            primary: true,
            click: this.adhereActions,
          },
        ]
      } else {
        this.adhereButtons = [
          {
            label: 'anterior',
            primary: false,
            click: () =>
              this.state.index > 0 && this.tabChange(this.state.index - 1),
            color: '#006736',
          },
          {
            label: 'seguinte',
            primary: true,
            click: this.adhereActions,
          },
        ]
      }
      this.setState({ index })
    } else {
      this.actions.setInvalid(invalid)
    }
  }

  toggleModal = (open = false) => {
    this.setState(
      { open },
      () =>
        !this.state.opened &&
        this.actions.reset() &&
        this.props.changeTariff(null)
    )
  }

  toggleErrorModal = () => {
    this.actions.setAdhesionError(null)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      currentTariff: nextProps.tariff,
    })

    if (nextProps.tariffInfo) {
      const {
        tariff,
        values: { potencia_contratada, ciclo_tarifa, municipality },
        simulation,
      } = nextProps
      const { priceListTimeCycle } = this.props.tariff
      const {
        subscription_requires_email,
        subscription_requires_phone,
      } = nextProps.tariffInfo.entity
      const isEleContract =
        nextProps.tariffInfo.pricelistadditionalinfo.electronic_contract
      isEleContract && this.setState({ tabs: ['Dados Pessoais', 'Finalizar'] })

      if (nextProps.firstSet && isEleContract) {
        if (tariff.suggested_electricity) {
          if (potencia_contratada) {
            this.changeField('electric', 'potency', potencia_contratada)
          }
          if (ciclo_tarifa) {
            this.changeField('electric', 'cycle', ciclo_tarifa)
          }
          if (priceListTimeCycle) {
            this.changeField('electric', 'tariff', priceListTimeCycle)
          }
        }

        if (simulation && simulation.gasStage) {
          this.changeField('gas', 'tier', simulation.gasStage)
        }

        if (municipality) {
          this.changeField('billing', 'municipality', municipality)
        }

        const detailsIndex = this.props.isHome ? 1 : 0
        if (this.validations) {
          delete this.validations[detailsIndex].personal.nif
          this.validations = this.validations.filter(
            (val) =>
              !Object.keys(val).find(
                (k) => k === 'billing' || k === 'electric' || k === 'gas'
              )
          )
        }
        this.actions.setFirstSet(false)
      }

      const detailsIndex = this.props.isHome ? 1 : 0
      if (this.validations) {
        let emailKey = 'email'
        let phoneKey = 'phone'
        const phone = this.validations[detailsIndex].personal[phoneKey]
        const email = this.validations[detailsIndex].personal[emailKey]

        if (subscription_requires_email && !email.length) {
          this.validations[detailsIndex].personal[emailKey].push(
            ...[required, isEmail]
          )
        }
        if (subscription_requires_phone && !phone.length) {
          this.validations[detailsIndex].personal[phoneKey].push(
            ...[required, isPhone]
          )
        }
      }
    }
  }

  hideDisclaimer = () => {
    this.adhereButtons = [
      {
        label: 'cancelar',
        primary: false,
        click: () => this.toggleModal(),
        color: '#006736',
      },
      {
        label: 'seguinte',
        primary: true,
        click: this.adhereActions,
      },
    ]
    this.setState({ showedDisclaimer: true })
  }

  componentWillMount() {
    const {
      tariff,
      values: { potencia_contratada, ciclo_tarifa, cae },
      simulation,
      tariffInfo,
      isHome,
    } = this.props
    const { priceListTimeCycle } = this.props.tariff

    let gasOrEletricity = []
    let eleSub = true
    let gasSub = true
    const isEleContract =
      !!tariffInfo && tariffInfo.pricelistadditionalinfo.electronic_contract

    if (tariff.electricityPriceList) {
      const {
        electricityPriceList: {
          entity: { can_subscribe: canSub },
        },
      } = tariff
      eleSub = canSub
    }
    if (tariff.gasPriceList) {
      const {
        gasPriceList: {
          entity: { can_subscribe: canSub },
        },
      } = tariff
      gasSub = canSub
    }
    if (!eleSub || !gasSub) {
      this.adhereButtons = [
        {
          label: 'Fechar',
          primary: true,
          click: () => this.toggleModal(),
        },
      ]
      this.setState({
        currentTariff: tariff,
        canSub: false,
        showedDisclaimer: true,
      })
    } else {
      if (tariff.electricityPriceList) {
        !isEleContract &&
          !isSimple &&
          !isHome &&
          gasOrEletricity.push('Fornecimento Eletricidade')
        if (potencia_contratada) {
          this.changeField('electric', 'potency', potencia_contratada)
        }
        if (ciclo_tarifa) {
          this.changeField('electric', 'cycle', ciclo_tarifa)
        }
        if (priceListTimeCycle) {
          this.changeField('electric', 'tariff', priceListTimeCycle)
        }
      }

      if (tariff.gasPriceList) {
        !isEleContract &&
          !isSimple &&
          !isHome &&
          gasOrEletricity.push('Fornecimento Gás Natural')

        if (simulation && simulation.gasStage) {
          this.changeField('gas', 'tier', simulation.gasStage)
        }
      }

      if (isEnterprise) {
        this.changeField('personal', 'companyCae', cae)
      }

      const billing = []
      if (!isEleContract) {
        billing.push('Morada')
      }

      const information = []
      if (this.props.isHome) {
        information.push('Informação geral')
      }

      const tabs = [
        ...information,
        isEnterprise ? 'Dados Empresariais' : 'Dados Pessoais',
        ...billing,
        ...gasOrEletricity,
        'Finalizar',
      ]

      let personalValidations = {}
      if (isEnterprise) {
        personalValidations = {
          name: [required],

          surname: [required],

          nif: [required, isNIF],

          email: [isEmail],

          phone: [isPhone],

          companyName: [required],

          companyCae: [required],

          companyPhoneNumber: [required],

          companyEmail: [isEmail],

          legalBi: [required],

          contact: [required],

          contact_time: [[isContactPhone], required],
        }
      } else {
        personalValidations = {
          name: [required],

          surname: [required],

          nif: [required, isNIF],

          /*
           * these validations are added later now that
           * entities can control if email or phone are required
           */
          email: [],
          phone: [],

          contact: [required],

          contact_time: [[isContactPhone], required],
        }
      }

      if (isHome) {
        this.validations = [{ info: {} }, { personal: personalValidations }]
      } else {
        this.validations = [{ personal: personalValidations }]
      }

      if (!isEleContract) {
        this.validations.push({
          billing: {
            postalCode: [required],
            postalExtension: [required],
            street: [required],
            door: [required],
            district: [required],
            municipality: [required],
            billingPostalCode: [[hasBillingAddress], required],
            billingPostalExtension: [[hasBillingAddress], required],
            billingStreet: [[hasBillingAddress], required],
            billingDoor: [[hasBillingAddress], required],
            billingDistrict: [[hasBillingAddress], required],
            billingMunicipality: [[hasBillingAddress], required],
          },
        })
      }

      if (isEleContract) {
        const detailsIndex = this.props.isHome ? 1 : 0
        delete this.validations[detailsIndex].personal.nif
      }

      if (
        tariff.electricityPriceList &&
        !isEleContract &&
        !isSimple &&
        !isHome
      ) {
        this.validations.push({
          electric: {
            cpe: [required, cepCui],
            potency: [required],
            tariff: [required],
            cycle: [required],
          },
        })
      }

      if (tariff.gasPriceList && !isEleContract && !isSimple && !isHome) {
        this.validations.push({
          gas: {
            cui: [required, cepCui],
            tier: [required],
          },
        })
      }

      this.validations.push({
        confirm: {
          allowDataSharing: [isChecked],
        },
      })

      this.setState({ currentTariff: tariff, tabs })
    }

    if (this.props.isHome) {
      this.changeField(
        'electric',
        'potency',
        parseFloat(this.props.tariff.calculatedHiredPowerFactor)
      )
      this.changeField('gas', 'tier', parseFloat(this.props.tariff.gasStage))
    }
  }

  componentWillUnmount() {
    this.setState({ index: 0, currentTariff: null })
    this.actions.setTariffInfo(null)
  }

  changeField = (key, property, value) => {
    const section = Object.assign({}, this.props.formData[key])
    const field = Object.assign({}, section[property], { value })
    const data = Object.assign(this.props.formData, {
      [key]: { ...section, [property]: field },
    })
    if (property === 'district' || property === 'billingDistrict') {
      this.actions.fetchMunicipalitiesTrigger(value, property)
    }
    this.actions.setFormData(data)
  }

  getPostal = ({ code, ext, type }) => {
    this.actions.fetchPostalInfo(code, ext, type)
  }

  errorsList(errors) {
    return Object.keys(errors).map((key) => {
      let field
      if (key === 'cuicpe') {
        field = (
          <div key={key}>
            Estes {translateErrors[key][0]} e {translateErrors[key][1]} aderiram
            a um tarifário recentemente. Tem de aguardar 30 dias para efetuar
            uma nova adesão no Poupa Energia. Se tiver dúvidas ligue-nos para o
            211 160 500.
          </div>
        )
      } else if (key === 'cui' || key === 'cpe') {
        field = (
          <div key={key}>
            Este {translateErrors[key]} aderiu a um tarifário recentemente. Tem
            de aguardar 30 dias para efetuar uma nova adesão no Poupa Energia.
            Se tiver dúvidas ligue-nos para o 211 160 500.
          </div>
        )
      } else {
        field = (
          <div key={key}>O campo {translateErrors[key]} contém erros.</div>
        )
      }
      return field
    })
  }

  render() {
    if (this.props.adhesionResponse) {
      this.adhereButtons = [
        {
          label: 'fechar',
          primary: false,
          click: () => this.toggleModal(),
          color: '#006736',
        },
      ]
    }

    if (this.props.confirmationError) {
      this.adhereButtons = [
        {
          label: 'cancelar',
          primary: false,
          click: () => {
            this.state.index > 0 && this.tabChange(this.state.index)
            this.actions.setConfirmationError(false)
          },
          color: '#006736',
        },
        {
          label: 'Aderir',
          primary: true,
          click: () =>
            this.actions.submitForm(this.transformForm(this.props.formData), {
              omitRepeated: true,
            }),
        },
      ]
    }

    const { translations, userProfile } = this.props
    const {
      SUCCESS_SUBSCRIPTION_EMAIL,
      SUCCESS_SUBSCRIPTION_MERCHANT,
      CONFIRMATION_TIME_ERROR,
      ESCLARECIMENTO_CUSTOS_ADICIONAIS,
      ESCLARECIMENTO_CONTACTE,
      ESCLARECIMENTO_PONTO_4,
      ESCLARECIMENTO_PONTO_3,
      ESCLARECIMENTO_PONTO_2,
      ESCLARECIMENTO_PONTO_1,
      ESCLARECIMENTO_INDISPONIVEL,
      COMO_FUNCIONA_TITLE,
      COMO_FUNCIONA_1,
      COMO_FUNCIONA_2,
      COMO_FUNCIONA_3,
      SHARE_TEXT,
    } = translations || {}

    let designation
    if (this.state.currentTariff && this.state.currentTariff.c) {
      designation = this.state.currentTariff.electricityPriceList.designation
    }
    if (this.state.currentTariff && this.state.currentTariff.gasPriceList) {
      designation = this.state.currentTariff.gasPriceList.designation
    }

    let shareText = ''

    if (this.props.tariffInfo) {
      shareText = SHARE_TEXT.replace(
        '{TARIFARIO}',
        this.props.tariffInfo.designation
      )
      shareText = shareText.replace(
        '{COMERCIALIZADOR}',
        this.props.tariffInfo.entity.designation
      )
      shareText = shareText.replace(
        '{POUPANCA}',
        unitCurrency(
          Number(
            Math.abs(
              this.props.tariff.annual_savings ||
                this.props.tariff.annualSavings
            )
          ).toFixed(0)
        )
      )
    }

    return (
      this.state.currentTariff &&
      this.state && (
        <ScrollModal
          title='adesão ao tarifário:'
          subtitle={designation}
          toggle={this.state.open}
          onClick={this.toggleModal}
          custom={false}
          buttons={this.adhereButtons}
          closeOnBackground={false}
          side={() => {
            return (
              <div style={{ paddingLeft: 40, paddingRight: 40, color: '#fff' }}>
                <img
                  src={InfoIcon}
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'block',
                  }}
                  alt={'Informações'}
                />
                <h2
                  style={{
                    textTransform: 'uppercase',
                    color: '#fff',
                    marginTop: '15px',
                  }}>
                  {COMO_FUNCIONA_TITLE}
                </h2>
                <ul style={{ margin: 0 }}>
                  <li style={{ marginBottom: 20 }}>{COMO_FUNCIONA_1}</li>
                  <li style={{ marginBottom: 20 }}>{COMO_FUNCIONA_2}</li>
                  <li>{COMO_FUNCIONA_3}</li>
                </ul>
              </div>
            )
          }}>
          {!this.props.adhesionResponse &&
            !this.props.confirmationError &&
            this.state.showedDisclaimer &&
            this.state.canSub &&
            this.props.tariffInfo && (
              <div>
                <Tabs
                  tabs={this.state.tabs}
                  onClick={this.tabChange}
                  hasProgress
                  currentIndex={this.state.index}
                />
                <TariffSubscribeForm
                  isHome={this.props.isHome}
                  userProfile={userProfile}
                  postalInfo={this.props.postalInfo}
                  getPostal={this.getPostal}
                  municipality={this.props.municipality}
                  index={this.state.index}
                  tariff={this.props.tariff}
                  fetchPostalInfo={this.actions.fetchPostalInfo}
                  tariffInfo={this.props.tariffInfo}
                  electricEntities={this.props.electricEntities}
                  gasEntities={this.props.gasEntities}
                  onChange={this.changeField}
                  hasEletricity={this.props.tariff.electricityPriceList}
                  hasGas={this.props.tariff.gasPriceList}
                  numberOfTabs={this.state.tabs.length}
                  formData={this.props.formData}
                  filters={this.props.values}
                  districts={this.props.districts}
                  municipalities={this.props.municipalities}
                  billingMunicipalities={this.props.billingMunicipalities}
                  caes={this.props.data && this.props.data.caes}
                  loadingAddress={this.props.loadingAddress}
                  addressNotFound={this.props.addressNotFound}
                  isSimple={isSimple || this.props.isHome}
                />
              </div>
            )}
          {this.props.adhesionResponse && this.state.showedDisclaimer && (
            <SuccessMessage>
              <img alt='' src={Smiley} />
              <SuccessTitle>
                Pré-adesão <span>{this.props.adhesionResponse.code}</span>{' '}
                submetida com sucesso
              </SuccessTitle>
              <SuccessInfo>
                {SUCCESS_SUBSCRIPTION_MERCHANT}
                {!isEnterprise && this.props.formData.personal.email.value && (
                  <span>
                    {SUCCESS_SUBSCRIPTION_EMAIL}{' '}
                    {this.props.formData.personal.email.value}
                  </span>
                )}
                {isEnterprise &&
                  this.props.formData.personal.companyEmail.value && (
                    <span>
                      {SUCCESS_SUBSCRIPTION_EMAIL}{' '}
                      {this.props.formData.personal.companyEmail.value}
                    </span>
                  )}
              </SuccessInfo>
              <ShareComponent
                style={{ marginTop: '46px' }}
                shareContent={shareText}
                shareUrl={'poupaenergia.pt'}
                shareTitle={`Poupa Energia`}
              />
            </SuccessMessage>
          )}

          {this.props.confirmationError &&
            !this.props.adhesionResponse &&
            this.state.showedDisclaimer && (
              <SuccessMessage>
                <ConfirmationError>{CONFIRMATION_TIME_ERROR}</ConfirmationError>
              </SuccessMessage>
            )}

          {this.props.adhesionError && (
            <ErrorModal
              title='Aviso'
              toggle={this.state.errorOpened}
              onClick={this.toggleErrorModal}
              custom={false}>
              {this.props.adhesionError &&
                this.props.adhesionError.response.data &&
                !(typeof this.props.adhesionError.response.data === 'string') &&
                this.errorsList(this.props.adhesionError.response.data)}
              {this.props.adhesionError &&
                this.props.adhesionError.response.data &&
                typeof this.props.adhesionError.response.data === 'string' && (
                  <span>Ocorreu um erro</span>
                )}
            </ErrorModal>
          )}

          {!this.state.showedDisclaimer && (
            <Disclaimer>
              <DisclaimerTitle>Esclarecimento</DisclaimerTitle>
              {this.props.tariffInfo &&
                hasPaidServices(this.props.tariffInfo.additional_services) && (
                  <DisclaimerText red>
                    {ESCLARECIMENTO_CUSTOS_ADICIONAIS}
                  </DisclaimerText>
                )}

              <DisclaimerText>
                <ListBall />
                {ESCLARECIMENTO_PONTO_1}
              </DisclaimerText>
              <DisclaimerText>
                <ListBall />
                {ESCLARECIMENTO_PONTO_2}
              </DisclaimerText>
              <DisclaimerText>
                <ListBall />
                {ESCLARECIMENTO_PONTO_3}
              </DisclaimerText>
              <DisclaimerText>
                <ListBall />
                {ESCLARECIMENTO_PONTO_4}
              </DisclaimerText>
              <DisclaimerTitle>{ESCLARECIMENTO_CONTACTE}</DisclaimerTitle>
            </Disclaimer>
          )}

          {!this.state.canSub && (
            <Disclaimer>
              <DisclaimerTitle>Esclarecimentos</DisclaimerTitle>
              <DisclaimerText>{ESCLARECIMENTO_INDISPONIVEL}</DisclaimerText>
              <DisclaimerTitle>{ESCLARECIMENTO_CONTACTE}</DisclaimerTitle>
            </Disclaimer>
          )}

          {!this.props.adhesionResponse &&
            this.state.showedDisclaimer &&
            this.state.canSub &&
            !this.props.tariffInfo && (
              <Placeholder>
                <CenteredLoading />
              </Placeholder>
            )}
        </ScrollModal>
      )
    )
  }
}

export default Logic(TariffSubscribeModal)

// {this.props.confirmationError &&
const ErrorModal = styled(Modal)`
  > div:last-child {
    height: 100%;

    > div:first-child {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding-bottom: 50px;
    }
  }
`

const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;
  align-items: center;
  justify-content: center;

  img {
    width: 87px;
    height: 64px;
    margin-bottom: 50px;
  }
`

const SuccessTitle = styled.h3`
  color: #010101;
  font-family: Nunito;
  font-size: 20px;
  font-weight: bold;
  line-height: 28px;
  text-align: center;
  margin-bottom: 16px;
  text-transform: uppercase;
`

const SuccessInfo = styled.div`
  color: #010101;
  font-family: Nunito;
  font-size: 14px;
  line-height: 20px;
`

const ConfirmationError = styled.div`
  color: #010101;
  font-family: Nunito;
  font-size: 19px;
  line-height: 34px;
  text-align: center;
`

const ScrollModal = styled(Modal)`
  overflow: auto;
  padding-bottom: 100px;
  height: initial;
  bottom: 0;
  text-align: initial;
`

const Disclaimer = styled.div`
  padding: 20px 0;
`

const DisclaimerTitle = styled.span`
  display: block;
  font-weight: bold;
  margin-bottom: 20px;
  color: #8abb3f;
`

const DisclaimerText = styled.div`
  margin-bottom: 10px;

  ${({ red }) =>
    red &&
    `
  color: indianred;
  `}
`

const ListBall = styled.div`
  width: 10px;
  height: 10px;
  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);
  display: inline-block;
  border-radius: 50%;
  margin-right: 10px;
`

const Placeholder = styled.div`
  height: 350px;
`

const CenteredLoading = styled(Loading)`
  min-height: initial;
`

const ShareComponent = ({ shareUrl, shareContent, shareTitle }) => {
  return (
    <ShareBoxContainer style={{ position: 'relative' }}>
      <ShareBox>
        <div className='sharebox-icon'>
          <svg
            width={24}
            height={26}
            viewBox='0 0 24 26'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M19.333 23.44c-1.142 0-2.077-.918-2.077-2.04 0-.097.006-.186.024-.276a2.017 2.017 0 01.8-1.345 2.07 2.07 0 011.253-.42c1.143 0 2.078.918 2.078 2.041 0 1.122-.935 2.04-2.078 2.04m-14.666-8.4c-1.143 0-2.078-.918-2.078-2.04 0-1.123.935-2.04 2.078-2.04.47 0 .904.155 1.252.42.428.318.728.797.801 1.344.018.09.024.18.024.276 0 .096-.006.186-.024.276a2.016 2.016 0 01-.8 1.344 2.07 2.07 0 01-1.253.42M17.256 4.6c0-1.123.935-2.04 2.077-2.04 1.143 0 2.078.917 2.078 2.04 0 1.122-.935 2.04-2.078 2.04-.47 0-.904-.156-1.252-.42a2.016 2.016 0 01-.801-1.344 1.365 1.365 0 01-.024-.276m2.077 13.2a3.667 3.667 0 00-2.689 1.157l-8.482-4.859a3.624 3.624 0 000-2.196l8.482-4.86a3.666 3.666 0 002.69 1.158C21.355 8.2 23 6.586 23 4.6S21.356 1 19.333 1c-2.022 0-3.666 1.614-3.666 3.6 0 .384.06.75.17 1.098l-8.481 4.86A3.666 3.666 0 004.666 9.4C2.645 9.4 1 11.014 1 13c0 1.985 1.644 3.6 3.667 3.6a3.668 3.668 0 002.689-1.158l8.482 4.86c-.11.348-.171.714-.171 1.098 0 1.985 1.644 3.6 3.666 3.6C21.356 25 23 23.385 23 21.4c0-1.986-1.644-3.6-3.667-3.6'
              fill='#FFF'
              fillRule='nonzero'
              stroke='#FFF'
              strokeWidth={0.6}
            />
          </svg>
        </div>
        <div className='sharebox-text'>
          Partilhe a sua adesão e ajude os seus amigos a poupar!
        </div>
        <div className='sharebox-carrot'>
          <svg
            width={8}
            height={12}
            viewBox='0 0 8 12'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M.337 9.78a1.333 1.333 0 001.993 1.772l5.333-4.666a1.333 1.333 0 000-1.772L2.33.448A1.333 1.333 0 00.337 2.219L4.883 6 .337 9.78z'
              fillRule='nonzero'
              fill='#010101'
              strokeWidth={0.2}
            />
          </svg>
        </div>
      </ShareBox>

      <div className='sharebox-dialog'>
        <a
          className='resp-sharing-button__link'
          href={`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            shareUrl
          )}&quote=${encodeURIComponent(shareContent)}`}
          target='_blank'
          rel='noopener'
          aria-label=''>
          <div className='resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small'>
            <div
              aria-hidden='true'
              className='resp-sharing-button__icon resp-sharing-button__icon--solidcircle'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                <path d='M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm3.6 11.5h-2.1v7h-3v-7h-2v-2h2V8.34c0-1.1.35-2.82 2.65-2.82h2.35v2.3h-1.4c-.25 0-.6.13-.6.66V9.5h2.34l-.24 2z' />
              </svg>
            </div>
          </div>
        </a>

        <a
          className='resp-sharing-button__link'
          href={`https://twitter.com/intent/tweet/?text=${encodeURIComponent(
            shareContent
          )}&url=${encodeURIComponent(shareUrl)}`}
          target='_blank'
          rel='noopener'
          aria-label=''>
          <div className='resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small'>
            <div
              aria-hidden='true'
              className='resp-sharing-button__icon resp-sharing-button__icon--solidcircle'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                <path d='M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm5.26 9.38v.34c0 3.48-2.64 7.5-7.48 7.5-1.48 0-2.87-.44-4.03-1.2 1.37.17 2.77-.2 3.9-1.08-1.16-.02-2.13-.78-2.46-1.83.38.1.8.07 1.17-.03-1.2-.24-2.1-1.3-2.1-2.58v-.05c.35.2.75.32 1.18.33-.7-.47-1.17-1.28-1.17-2.2 0-.47.13-.92.36-1.3C7.94 8.85 9.88 9.9 12.06 10c-.04-.2-.06-.4-.06-.6 0-1.46 1.18-2.63 2.63-2.63.76 0 1.44.3 1.92.82.6-.12 1.95-.27 1.95-.27-.35.53-.72 1.66-1.24 2.04z' />
              </svg>
            </div>
          </div>
        </a>
        <a
          className='resp-sharing-button__link'
          href={`mailto:?subject=${encodeURIComponent(
            shareTitle
          )}&body=${encodeURIComponent(`${shareContent} ${shareUrl}`)}`}
          target='_self'
          rel='noopener'
          aria-label=''>
          <div className='resp-sharing-button resp-sharing-button--email resp-sharing-button--small'>
            <div
              aria-hidden='true'
              className='resp-sharing-button__icon resp-sharing-button__icon--solidcircle'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                <path d='M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm8 16c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8z' />
                <path d='M17.9 8.18c-.2-.2-.5-.24-.72-.07L12 12.38 6.82 8.1c-.22-.16-.53-.13-.7.08s-.15.53.06.7l3.62 2.97-3.57 2.23c-.23.14-.3.45-.15.7.1.14.25.22.42.22.1 0 .18-.02.27-.08l3.85-2.4 1.06.87c.1.04.2.1.32.1s.23-.06.32-.1l1.06-.9 3.86 2.4c.08.06.17.1.26.1.17 0 .33-.1.42-.25.15-.24.08-.55-.15-.7l-3.57-2.22 3.62-2.96c.2-.2.24-.5.07-.72z' />
              </svg>
            </div>
          </div>
        </a>

        <a
          className='resp-sharing-button__link'
          href={`https://wa.me/?text=${encodeURIComponent(
            shareContent
          )} ${encodeURIComponent(shareUrl)}`}
          target='_blank'
          rel='noopener'
          aria-label=''>
          <div className='resp-sharing-button resp-sharing-button--whatsapp resp-sharing-button--small'>
            <div
              aria-hidden='true'
              className='resp-sharing-button__icon resp-sharing-button__icon--solidcircle'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                height='24'
                width='24'
                viewBox='0 0 24 24'>
                <path d='m12 0c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12zm0 3.8c2.2 0 4.2 0.9 5.7 2.4 1.6 1.5 2.4 3.6 2.5 5.7 0 4.5-3.6 8.1-8.1 8.1-1.4 0-2.7-0.4-3.9-1l-4.4 1.1 1.2-4.2c-0.8-1.2-1.1-2.6-1.1-4 0-4.5 3.6-8.1 8.1-8.1zm0.1 1.5c-3.7 0-6.7 3-6.7 6.7 0 1.3 0.3 2.5 1 3.6l0.1 0.3-0.7 2.4 2.5-0.7 0.3 0.099c1 0.7 2.2 1 3.4 1 3.7 0 6.8-3 6.9-6.6 0-1.8-0.7-3.5-2-4.8s-3-2-4.8-2zm-3 2.9h0.4c0.2 0 0.4-0.099 0.5 0.3s0.5 1.5 0.6 1.7 0.1 0.2 0 0.3-0.1 0.2-0.2 0.3l-0.3 0.3c-0.1 0.1-0.2 0.2-0.1 0.4 0.2 0.2 0.6 0.9 1.2 1.4 0.7 0.7 1.4 0.9 1.6 1 0.2 0 0.3 0.001 0.4-0.099s0.5-0.6 0.6-0.8c0.2-0.2 0.3-0.2 0.5-0.1l1.4 0.7c0.2 0.1 0.3 0.2 0.5 0.3 0 0.1 0.1 0.5-0.099 1s-1 0.9-1.4 1c-0.3 0-0.8 0.001-1.3-0.099-0.3-0.1-0.7-0.2-1.2-0.4-2.1-0.9-3.4-3-3.5-3.1s-0.8-1.1-0.8-2.1c0-1 0.5-1.5 0.7-1.7s0.4-0.3 0.5-0.3z' />
              </svg>
            </div>
          </div>
        </a>
      </div>
    </ShareBoxContainer>
  )
}

const ShareBoxContainer = styled.div`
  position: relative;

  .resp-sharing-button__link,
  .resp-sharing-button__icon {
    display: inline-block;
  }

  .resp-sharing-button__link {
    text-decoration: none;
    color: #fff;
    margin: 0.5em;
  }

  .resp-sharing-button {
    border-radius: 5px;
    transition: 25ms ease-out;
    padding: 0.5em 0.75em;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  }

  .resp-sharing-button__icon svg {
    width: 1em;
    height: 1em;
    margin-right: 0.4em;
    vertical-align: top;
  }

  .resp-sharing-button--small svg {
    margin: 0;
    vertical-align: middle;
  }

  /* Non solid icons get a stroke */
  .resp-sharing-button__icon {
    stroke: #fff;
    fill: none;
  }

  /* Solid icons get a fill */
  .resp-sharing-button__icon--solid,
  .resp-sharing-button__icon--solidcircle {
    fill: #fff;
    stroke: none;
  }

  .resp-sharing-button--twitter {
    background-color: #55acee;
  }

  .resp-sharing-button--twitter:hover {
    background-color: #2795e9;
  }

  .resp-sharing-button--pinterest {
    background-color: #bd081c;
  }

  .resp-sharing-button--pinterest:hover {
    background-color: #8c0615;
  }

  .resp-sharing-button--facebook {
    background-color: #3b5998;
  }

  .resp-sharing-button--facebook:hover {
    background-color: #2d4373;
  }

  .resp-sharing-button--tumblr {
    background-color: #35465c;
  }

  .resp-sharing-button--tumblr:hover {
    background-color: #222d3c;
  }

  .resp-sharing-button--reddit {
    background-color: #5f99cf;
  }

  .resp-sharing-button--reddit:hover {
    background-color: #3a80c1;
  }

  .resp-sharing-button--google {
    background-color: #dd4b39;
  }

  .resp-sharing-button--google:hover {
    background-color: #c23321;
  }

  .resp-sharing-button--linkedin {
    background-color: #0077b5;
  }

  .resp-sharing-button--linkedin:hover {
    background-color: #046293;
  }

  .resp-sharing-button--email {
    background-color: #777;
  }

  .resp-sharing-button--email:hover {
    background-color: #5e5e5e;
  }

  .resp-sharing-button--xing {
    background-color: #1a7576;
  }

  .resp-sharing-button--xing:hover {
    background-color: #114c4c;
  }

  .resp-sharing-button--whatsapp {
    background-color: #25d366;
  }

  .resp-sharing-button--whatsapp:hover {
    background-color: #1da851;
  }

  .resp-sharing-button--hackernews {
    background-color: #ff6600;
  }
  .resp-sharing-button--hackernews:hover,
  .resp-sharing-button--hackernews:focus {
    background-color: #fb6200;
  }

  .resp-sharing-button--vk {
    background-color: #507299;
  }

  .resp-sharing-button--vk:hover {
    background-color: #43648c;
  }

  .resp-sharing-button--facebook {
    background-color: #3b5998;
    border-color: #3b5998;
  }

  .resp-sharing-button--facebook:hover,
  .resp-sharing-button--facebook:active {
    background-color: #2d4373;
    border-color: #2d4373;
  }

  .resp-sharing-button--twitter {
    background-color: #55acee;
    border-color: #55acee;
  }

  .resp-sharing-button--twitter:hover,
  .resp-sharing-button--twitter:active {
    background-color: #2795e9;
    border-color: #2795e9;
  }

  .resp-sharing-button--email {
    background-color: #777777;
    border-color: #777777;
  }

  .resp-sharing-button--email:hover,
  .resp-sharing-button--email:active {
    background-color: #5e5e5e;
    border-color: #5e5e5e;
  }

  .resp-sharing-button--whatsapp {
    background-color: #25d366;
    border-color: #25d366;
  }

  .resp-sharing-button--whatsapp:hover,
  .resp-sharing-button--whatsapp:active {
    background-color: #1da851;
    border-color: #1da851;
  }

  .sharebox-dialog {
    display: none;
    position: absolute;
    left: 80px;
    top: 50%;
    transform: translateY(-50%);
  }

  &:hover {
    .sharebox-dialog {
      display: block;
    }

    .sharebox-text {
      opacity: 0;
    }
  }
`

const ShareBox = styled.div`
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  .sharebox-icon {
    width: 60px;
    height: 60px;
    background: linear-gradient(270deg, #006736 0%, #93c13e 100%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sharebox-text {
    padding: 0 24px;
    flex: 1;
    color: #010101;
    font-family: Nunito;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 16px;
  }

  .sharebox-carrot {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`



// WEBPACK FOOTER //
// ./src/containers/TariffSubscribeModal/index.js